import { isAndroid } from '@/util/browser.js';
import * as swcBridge from '@/util/jsbridge/index';
import * as universalBridge from '@/util/platform/universal-bridge';

export function isInNioCNAppSwc() {
    return typeof getJsBridge !== 'undefined';
}

const webviewBridgeMap = {
    isInNioCNApp: {
        swc: isInNioCNAppSwc,
        lg: universalBridge.isInNioCNApp
    },
    redirectToViewBridge: {
        swc: async url => {
            // ios app里redirectToViewBridge(nio://web/view?url=xx) 打不开，但可以直接跳转url和其他schema
            // 安卓 app里redirectToViewBridge(url)会唤起端外浏览器，但可以跳schema
            if (url.startsWith('http') && isAndroid()) {
                return swcBridge.redirectToViewBridge(
                    `nio://web/view?url=${encodeURIComponent(url)}`
                );
            }
            return swcBridge.redirectToViewBridge(url);
        },
        lg: universalBridge.redirectToViewBridge
    },
    redirectToLoginViewBridge: {
        swc: swcBridge.redirectToLoginViewBridge,
        lg: universalBridge.redirectToLoginViewBridge
    },
    getLoginInfoBridge: {
        swc: async () => {
            try {
                const data = await swcBridge.getLoginInfoBridge();

                return { result_code: 'success', data };
            } catch (e) {
                console.warn('[swc getLoginInfo] failed ', e);
                return {
                    result_code: 'fail',
                    display_message: 'fail',
                    data: {}
                };
            }
        },
        lg: universalBridge.getLoginInfoBridge
    },
    getLocationBridge: {
        swc: async () => {
            const { type, result } = await swcBridge.getLocationBridge();

            if (type === 'success') {
                return {
                    result_code: type,
                    data: {
                        lat: result.point.lat,
                        lng: result.point.lng,
                        city: result.city.city,
                        cityCode: result.city.cityCode
                    }
                };
            }
            return {
                result_code: type,
                display_message: result.message || type,
                data: {}
            };
        },
        lg: universalBridge.getLocationBridge
    },
    copyBridge: {
        swc: async content => {
            const res = await swcBridge.copyBridge(content);
            return {
                result_code: res.result || 'success',
                data: {}
            };
        },
        lg: universalBridge.copyBridge
    },
    closePageBridge: {
        swc: swcBridge.closePageBridge,
        lg: universalBridge.closePageBridge
    },
    applyJoinGroupBridge: {
        swc: async (groupId, inviterId) => {
            try {
                const res = await swcBridge.applyJoinGroupBridge(
                    groupId,
                    inviterId
                );
                return {
                    result_code: 'success',
                    data: res
                };
            } catch (e) {
                console.warn('[swc applyJoinGroup] failed', e);
                return {
                    result_code: e.type,
                    display_message: '暂不支持',
                    data: {}
                };
            }
        },
        lg: universalBridge.applyJoinGroupBridge
    },
    showNativeLoading: {
        swc: swcBridge.showNativeLoading,
        lg: universalBridge.showNativeLoading
    },
    destroyNativeLoading: {
        swc: swcBridge.destroyNativeLoading,
        lg: universalBridge.destroyNativeLoading
    }
};

// 兼容swc/lg
function callBridge(bridgeName, ...args) {
    const wv = universalBridge.isInLg() ? 'lg' : 'swc';
    return webviewBridgeMap[bridgeName][wv](...args);
}

export const handleBridgeCallback = universalBridge.handleBridgeCallback;
export const isInNioCNApp = () => callBridge('isInNioCNApp');
export const redirectToViewBridge = url =>
    callBridge('redirectToViewBridge', url);
export const redirectToLoginViewBridge = () =>
    callBridge('redirectToLoginViewBridge');
export const getLoginInfoBridge = () => callBridge('getLoginInfoBridge');
export const getLoginInfo = universalBridge.getLoginInfoBridge;
export const getLocationBridge = context =>
    callBridge('getLocationBridge', context);
export const copyBridge = content => callBridge('copyBridge', content);
export const closePageBridge = () => callBridge('closePageBridge');
export const applyJoinGroupBridge = (groupId, inviterId) =>
    callBridge('applyJoinGroupBridge', groupId, inviterId);
export const showNativeLoading = content => callBridge('showNativeLoading', content);
export const destroyNativeLoading = content => callBridge('destroyNativeLoading', content);



// WEBPACK FOOTER //
// ./src/util/platform/universal.js